(() => {
  const STORAGE_KEY = 'bonvila_postcode';
  const CART_ATTRIBUTE_KEY = 'Delivery postcode';

  const configElement = document.getElementById('BonvilaPostcodeConfig');

  if (!configElement) return;

  let config = {};

  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error('Bonvila postcode configuration could not be loaded.', error);
    return;
  }

  const normaliseList = (value = '') =>
    value
      .split(',')
      .map((item) => item.trim().toUpperCase())
      .filter(Boolean);

  const londonOutcodes = normaliseList(config.londonOutcodes);
  const twoDayPrefixes = normaliseList(config.twoDayPrefixes);

  const ukPostcodeRegex =
    /^([A-Z]{1,2}[0-9][A-Z0-9]?\s?[0-9][A-Z]{2}|GIR\s?0AA)$/i;

  const truckIcon = `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3 6.5h11v10H3z"></path>
      <path d="M14 10h3.8L21 13.2v3.3h-7z"></path>
      <circle cx="7.5" cy="17.5" r="1.5"></circle>
      <circle cx="17.5" cy="17.5" r="1.5"></circle>
    </svg>
  `;

  const formatPostcode = (postcode) => {
    const cleaned = String(postcode || '')
      .toUpperCase()
      .replace(/\s+/g, '')
      .trim();

    if (cleaned.length <= 3) return cleaned;

    return `${cleaned.slice(0, -3)} ${cleaned.slice(-3)}`;
  };

  const getOutcode = (postcode) => {
    const cleaned = String(postcode || '')
      .toUpperCase()
      .replace(/\s+/g, '')
      .trim();

    return cleaned.length >= 4 ? cleaned.slice(0, -3) : '';
  };

  const getDeliveryRegion = (postcode) => {
    const outcode = getOutcode(postcode);

    if (!outcode) return 'unknown';

    if (londonOutcodes.includes(outcode)) {
      return 'london';
    }

    if (twoDayPrefixes.some((prefix) => outcode.startsWith(prefix))) {
      return 'two-day';
    }

    return 'next-day';
  };

  const getDeliveryCopy = (region) => {
  if (region === 'london') {
    return {
      title: 'Bonvila Service available in your area',
      copy: 'Great news - your postcode is covered by Bonvila Service. Deliveries take place every Tuesday and Thursday, between 2pm and 6pm.'
    };
  }

  if (region === 'two-day') {
    return {
      title: 'DHL delivery available in your area',
      copy: 'Your postcode is covered by DHL delivery. Orders to Scotland, Wales and Northern Ireland arrive within 2 working days.'
    };
  }

  if (region === 'next-day') {
    return {
      title: 'DHL Next Day Delivery available',
      copy: 'Great news - your postcode is covered by DHL Next Day Delivery.'
    };
  }

  return {
    title: 'We deliver across the UK',
    copy: 'Enter your postcode to see whether your order will be delivered by Bonvila Service or DHL.'
  };
};

  const getCurrentPostcode = () => localStorage.getItem(STORAGE_KEY) || '';

  const saveToCart = async (postcode) => {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            [CART_ATTRIBUTE_KEY]: postcode
          }
        })
      });
    } catch (error) {
      console.warn('Could not save delivery postcode to cart.', error);
    }
  };

  const setCurrentPostcode = async (postcode) => {
    const formatted = formatPostcode(postcode);

    localStorage.setItem(STORAGE_KEY, formatted);
    await saveToCart(formatted);

    document.dispatchEvent(
      new CustomEvent('bonvila:postcode-updated', {
        detail: {
          postcode: formatted,
          region: getDeliveryRegion(formatted)
        }
      })
    );
  };

  const clearCurrentPostcode = () => {
    localStorage.removeItem(STORAGE_KEY);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          [CART_ATTRIBUTE_KEY]: ''
        }
      })
    }).catch(() => {});

    document.dispatchEvent(
      new CustomEvent('bonvila:postcode-updated', {
        detail: {
          postcode: '',
          region: 'unknown'
        }
      })
    );
  };

  const closeAnnouncementPostcodeModal = (modal) => {
    if (!modal) return;

    modal.hidden = true;
    document.body.classList.remove('bonvila-postcode-modal-open');

    const trigger = document.querySelector(
      `[aria-controls="${modal.id}"]`
    );

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }
  };

  const openAnnouncementPostcodeModal = (trigger) => {
    const modalId = trigger.getAttribute('aria-controls');
    const modal = document.getElementById(modalId);

    if (!modal) return;

    modal.hidden = false;
    document.body.classList.add('bonvila-postcode-modal-open');
    trigger.setAttribute('aria-expanded', 'true');

    window.setTimeout(() => {
      modal.querySelector('[data-announcement-postcode-input]')?.focus();
    }, 60);
  };

  const updateAnnouncementBar = () => {
    const postcode = getCurrentPostcode();
    const region = getDeliveryRegion(postcode);
    const delivery = getDeliveryCopy(region);

    document
      .querySelectorAll('[data-bonvila-announcement-postcode]')
      .forEach((component) => {
        const label = component.querySelector(
          '[data-announcement-postcode-label]'
        );

        if (label) {
          label.textContent = postcode
            ? `Delivering to ${postcode}`
            : 'Check delivery to your area';
        }
      });

    document
      .querySelectorAll('[data-announcement-postcode-modal]')
      .forEach((modal) => {
        const input = modal.querySelector(
          '[data-announcement-postcode-input]'
        );

        const result = modal.querySelector(
          '[data-announcement-postcode-result]'
        );

        const removeButton = modal.querySelector(
          '[data-announcement-postcode-remove]'
        );

        if (input) {
          input.value = postcode;
        }

        if (result && postcode) {
          result.innerHTML = `
            <strong>${delivery.title}</strong>
            <span>${delivery.copy}</span>
          `;

          result.classList.add('is-visible');
        }

        if (result && !postcode) {
          result.innerHTML = '';
          result.classList.remove('is-visible');
        }

        if (removeButton) {
          removeButton.hidden = !postcode;
        }
      });
  };

  const updateProductComponents = () => {
    const postcode = getCurrentPostcode();
    const region = getDeliveryRegion(postcode);
    const delivery = getDeliveryCopy(region);

    document
      .querySelectorAll('[data-bonvila-postcode-product]')
      .forEach((component) => {
        const input = component.querySelector('[data-postcode-input]');
        const summary = component.querySelector('[data-postcode-summary]');
        const result = component.querySelector('[data-postcode-result]');

        if (input) {
          input.value = postcode;
        }

        if (summary) {
          summary.textContent = postcode
            ? `Delivery options for ${postcode}`
            : 'Check delivery for your area';
        }

        if (result) {
          result.innerHTML = `
            <span class="bonvila-postcode__result-icon">
              ${truckIcon}
            </span>
            <div>
              <span class="bonvila-postcode__result-title">
                ${delivery.title}
              </span>
              <p class="bonvila-postcode__result-copy">
                ${delivery.copy}
              </p>
            </div>
          `;
        }
      });
  };

  const updateAll = () => {
    updateAnnouncementBar();
    updateProductComponents();
  };

  const validateAndSave = async (input, message) => {
    const postcode = formatPostcode(input?.value || '');

    if (!postcode) {
      if (message) {
        message.textContent = 'Please enter your postcode.';
        message.classList.add('is-error');
      }

      return false;
    }

    if (!ukPostcodeRegex.test(postcode)) {
      if (message) {
        message.textContent = 'Please enter a valid UK postcode.';
        message.classList.add('is-error');
      }

      return false;
    }

    if (message) {
      message.textContent = 'Checking delivery options…';
      message.classList.remove('is-error');
    }

    await setCurrentPostcode(postcode);

    if (message) {
      message.textContent = 'Delivery area updated.';
      message.classList.remove('is-error');
    }

    updateAll();

    return true;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(
      '[data-announcement-postcode-trigger]'
    );

    if (trigger) {
      openAnnouncementPostcodeModal(trigger);
      return;
    }

    const closeButton = event.target.closest(
      '[data-announcement-postcode-close]'
    );

    const backdrop = event.target.closest(
      '[data-announcement-postcode-backdrop]'
    );

    if (closeButton || backdrop) {
      const modal = event.target.closest(
        '[data-announcement-postcode-modal]'
      );

      closeAnnouncementPostcodeModal(modal);
      return;
    }

    const removeButton = event.target.closest(
      '[data-announcement-postcode-remove]'
    );

    if (removeButton) {
      clearCurrentPostcode();
      updateAll();
      return;
    }

    const productToggle = event.target.closest(
      '[data-postcode-product-toggle]'
    );

    if (productToggle) {
      const component = productToggle.closest(
        '[data-bonvila-postcode-product]'
      );

      const body = component?.querySelector(
        '[data-postcode-product-body]'
      );

      if (!component || !body) return;

      body.hidden = !body.hidden;
      component.classList.toggle('is-open', !body.hidden);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document
      .querySelectorAll('[data-announcement-postcode-modal]')
      .forEach((modal) => {
        if (!modal.hidden) {
          closeAnnouncementPostcodeModal(modal);
        }
      });
  });

  document.addEventListener('submit', async (event) => {
    const announcementForm = event.target.closest(
      '[data-announcement-postcode-form]'
    );

    if (announcementForm) {
      event.preventDefault();

      const modal = announcementForm.closest(
        '[data-announcement-postcode-modal]'
      );

      const input = announcementForm.querySelector(
        '[data-announcement-postcode-input]'
      );

      const message = modal?.querySelector(
        '[data-announcement-postcode-message]'
      );

      const saved = await validateAndSave(input, message);

      if (saved) {
  const result = modal?.querySelector(
    '[data-announcement-postcode-result]'
  );

  if (result) {
    result.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }

  const submitButton = announcementForm.querySelector(
    '.bonvila-postcode-modal__submit'
  );

  if (submitButton) {
    submitButton.textContent = 'Delivery updated';

    window.setTimeout(() => {
      submitButton.textContent = 'Update postcode';
    }, 1800);
  }
}

      return;
    }

    const productForm = event.target.closest(
      '[data-bonvila-postcode-form]'
    );

    if (productForm) {
      event.preventDefault();

      const input = productForm.querySelector(
        '[data-postcode-input]'
      );

      const message = productForm.querySelector(
        '[data-postcode-message]'
      );

      await validateAndSave(input, message);
    }
  });

  document.addEventListener('bonvila:postcode-updated', updateAll);

  document.addEventListener('shopify:section:load', updateAll);

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) {
      updateAll();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
})();